import {
    PARTY_SUCCESSFUL_FETCH,
    SHOW_ERROR_MESSAGE
} from 'reducers/constants';

import HttpClient from "utils/HttpClient/HttpClient"

export const fetchParties = (searchCriteria, resolve, reject) => dispatch => {
    new HttpClient(true).get("oga/persons",
        {
            params: {
                searchCriteria: searchCriteria
            }
        })
        .then((response) => {
            dispatch({
                type: PARTY_SUCCESSFUL_FETCH,
                payload: response.data
            });
            resolve();
        })
        .catch((error) => {
            dispatch({
                type: SHOW_ERROR_MESSAGE,
                payload: error.message
            });
            reject();
        });
}


// WEBPACK FOOTER //
// ./src/reducers/party/partyActions.js